import React, { useState } from 'react';
import Validator from 'validatorjs';

import { Field, Form } from 'react-final-form';
import { CheckboxField, SelectField, TextField } from '/components/forms/fields';

import { ValidationService, CopyService } from '/services';

const purposeOptions = [
    {"value":"te koop","label": CopyService.get('estimateForm.fields.purposeOptions.forSale') },
    {"value":"te huur","label": CopyService.get('estimateForm.fields.purposeOptions.forRent') },
];

const categoryOptions = [
    {"value":"huis","label": CopyService.get('estimateForm.fields.categoryOptions.house')},
    {"value":"appartement","label": CopyService.get('estimateForm.fields.categoryOptions.appartment')},
    {"value":"grond","label": CopyService.get('estimateForm.fields.categoryOptions.ground')},
    {"value":"kantoor","label": CopyService.get('estimateForm.fields.categoryOptions.office')},
    {"value":"commercieel","label": CopyService.get('estimateForm.fields.categoryOptions.commercial')},
    {"value":"industrieel","label": CopyService.get('estimateForm.fields.categoryOptions.industrial')},
    {"value":"garage / parking","label": CopyService.get('estimateForm.fields.categoryOptions.parkingOrGarage')},
];

const EstimateForm = () => {
    const [error, setError] = useState(null);

    const validate = (values) => {
        const rules = {
            firstName: 'required',
            lastName: 'required',
            purpose: 'required',
            category: 'required',
            mobile: 'required',
            email: 'required',
            street: 'required',
            number: 'required',
            postalCode: 'required',
            city: 'required',
            privacy: 'required',
        };

        const names = {
            firstName: CopyService.get('firstName'),
            lastName: CopyService.get('lastName'),
            purpose: CopyService.get('purpose'),
            category: CopyService.get('category'),
            mobile: CopyService.get('mobile'),
            email: CopyService.get('email'),
            street: CopyService.get('street'),
            number: CopyService.get('number'),
            box: CopyService.get('box'),
            postalCode: CopyService.get('postalCode'),
            city: CopyService.get('city'),
        };

        return ValidationService.validate(values, rules, names);
    };

    const submit = async (values) => {
        const body = new FormData();
        body.append(window.csrfTokenName, window.csrfTokenValue);
        body.append('firstName', values.firstName);
        body.append('lastName', values.lastName);
        body.append('mobile', values.mobile);
        body.append('email', values.email);

        body.append('street', values.street);
        body.append('number', values.number);
        body.append('box', values.box);
        body.append('postalCode', values.postalCode);
        body.append('city', values.city);

        body.append('purpose', values.purpose && values.purpose.value);
        body.append('category', values.category && values.category.value);

        try {
            const response = await fetch('/index.php?p=actions/immodule/form/estimate', {
                method: 'post',
                body,
            });

            const bodyFromResponse = await response.json();

            if (bodyFromResponse.success) {
                window.location = window.successRedirect;
            } else {
                window.location = window.failureRedirect;
            }
        } catch {
            window.location = window.failureRedirect;
        }
    };

    const render = ({ handleSubmit }) => (
        <>
        { error && (
            <p className="estimate-form__error">{ error }</p>
        )}
        <form className="estimate-form" onSubmit={handleSubmit}>
            <Field
                name="firstName"
                component={TextField}
                label={CopyService.get('estimateForm.fields.firstName')}
                type="text"
                required
            />
            <Field
                name="lastName"
                component={TextField}
                label={CopyService.get('estimateForm.fields.lastName')}
                type="text"
                required
            />
            <Field
                name="purpose"
                component={SelectField}
                label={CopyService.get('estimateForm.fields.purpose')}
                options={purposeOptions}
                required
            />
            <Field
                name="category"
                component={SelectField}
                label={CopyService.get('estimateForm.fields.category')}
                options={categoryOptions}
                required
            />
            <Field
                name="mobile"
                component={TextField}
                label={CopyService.get('estimateForm.fields.mobile')}
                type="tel"
                required
            />
            <Field
                name="email"
                component={TextField}
                label={CopyService.get('estimateForm.fields.email')}
                type="email"
                required
            />
            <Field
                name="street"
                component={TextField}
                label={CopyService.get('estimateForm.fields.street')}
                type="text"
                required
            />
            <Field
                name="number"
                component={TextField}
                label={CopyService.get('estimateForm.fields.number')}
                type="number"
                required
            />
            <Field
                name="box"
                component={TextField}
                label={CopyService.get('estimateForm.fields.box')}
                type="text"
            />
            <Field
                name="postalCode"
                component={TextField}
                label={CopyService.get('estimateForm.fields.postalCode')}
                type="text"
                required
            />
            <Field
                name="city"
                component={TextField}
                label={CopyService.get('estimateForm.fields.city')}
                type="text"
                required
            />
            <Field
                name="privacy"
                component={CheckboxField}
                label={window.privacyMessage}
                type="checkbox"
                required
            />
            <button className="button is-orange font-supplementary--bold" type="submit">
                {CopyService.get('estimateForm.submit')}
            </button>
        </form>
        </>
    );

    return (
        <Form
            validate={validate}
            onSubmit={submit}
            render={render}
        />
    );
};

export { EstimateForm };
